import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=519ba244&"
import script from "./Checkbox.vue?vue&type=script&lang=ts&"
export * from "./Checkbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sush/Virtual/cublic-form-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('519ba244')) {
      api.createRecord('519ba244', component.options)
    } else {
      api.reload('519ba244', component.options)
    }
    module.hot.accept("./Checkbox.vue?vue&type=template&id=519ba244&", function () {
      api.rerender('519ba244', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resource/component/form/Field/Checkbox.vue"
export default component.exports